import React, { useState, useEffect } from "react";
// We'll create this CSS file next

const SliderWhite = ({ slides }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Auto-advance slides (optional)
  useEffect(() => {
    const interval = setInterval(() => {
      goToNext();
    }, 5000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const goToPrevious = () => {
    if (isTransitioning) return;

    setIsTransitioning(true);
    const newIndex = currentIndex === 0 ? slides.length - 1 : currentIndex - 1;

    setTimeout(() => {
      setCurrentIndex(newIndex);
      setIsTransitioning(false);
    }, 500);
  };

  const goToNext = () => {
    if (isTransitioning) return;

    setIsTransitioning(true);
    const newIndex = currentIndex === slides.length - 1 ? 0 : currentIndex + 1;

    setTimeout(() => {
      setCurrentIndex(newIndex);
      setIsTransitioning(false);
    }, 500);
  };

  const goToSlide = (index) => {
    if (isTransitioning || index === currentIndex) return;

    setIsTransitioning(true);

    setTimeout(() => {
      setCurrentIndex(index);
      setIsTransitioning(false);
    }, 500);
  };

  return (
    <div
      className="slider-white-container"
      
    >
      <div className="slider-white">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide-white ${index === currentIndex ? "active" : ""} ${
              isTransitioning ? "fading" : ""
            }`}
            style={{ backgroundColor: "#007bff" }}
          >
            <div className="About-us-section-7">
              <div
                
              >
                <div>
                  <h1>{slide.title}</h1>
                  <p>
                    {slide.description}
                  </p>
                </div>
              </div>
              <div style={{ backgroundImage: `url(${slide.image})` }}></div>
            </div>
          </div>
        ))}
      </div>

      <button className="slider-white-button left" onClick={goToPrevious}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 18L9 12L15 6"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <button className="slider-white-button right" onClick={goToNext}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 18L15 12L9 6"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <div className="slider-white-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`slider-white-dot ${
              index === currentIndex ? "active" : ""
            }`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default SliderWhite;
